import { Component, OnInit, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { PreCandidatoCsvDTO } from 'src/app/models/preCandidatoCsvDTO.model';
import { PreCandidatosService } from 'src/app/services/precandidatos.service';
import { PreCandidatoComponent } from '../../parametrizacoes/precandidato/precandidato.component';
import { Utils } from 'src/app/utils/utils';
import { CandidaturaService } from 'src/app/services/candidatura.service';

@Component({
  selector: 'cadastro-massa-precandidato',
  templateUrl: './precandidato-csv-import.component.html',
  styleUrls: ['./precandidato-csv-import.component.css']
})

export class PreCandidatoCsvComponent implements OnInit {
  idEleicao: any;
  token: any;
  candidaturaId:any;
  candidatosArray: PreCandidatoCsvDTO[] = [];
  newCandidatosArray: PreCandidatoCsvDTO[] = [];
  candidatosCriticados: any = [];
  candidatosEnviados: any = [];
  candidatosDuplicados: any = [];
  btOff: boolean = false;
  ativaNavValidacao: boolean = false;
  ativaNavEnviar: boolean = false;

  @Input() listaCargos: any;

  constructor(
    private candidatoComponent: PreCandidatoComponent,
    public canditadosService: PreCandidatosService,
    protected messageService: MessageService,
    protected candidaturaService: CandidaturaService,
    public utils: Utils,
  ) { }

  async ngOnInit() {
    this.token = sessionStorage.getItem("token");
    this.candidaturaId = await JSON.parse(sessionStorage.getItem("candidaturaId"));
    this.idEleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao")).id;
    
  }

  validaTipoArquivo(file: any) {
    return file.name.endsWith(".csv");
  }

  zerarInputFile(element?) {
    if (element) {
      element.value = '';
    }
    this.newCandidatosArray = [];
    this.candidatosCriticados = [];
    this.candidatosDuplicados = [];
    this.candidatosEnviados = [];
  }

  getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {
    let csvArr = [];

    for (let i = 1; i < csvRecordsArray.length; i++) {
      let currentRecord = csvRecordsArray[i].split(';');
      if (currentRecord.length == headerLength) {
        let csv: PreCandidatoCsvDTO = new PreCandidatoCsvDTO();
        csv.nome = currentRecord[0].trim();
        csv.cpf = currentRecord[1].trim();
        csv.cargo = { "nome": currentRecord[2].trim() };
        csv.curriculum = currentRecord[3].trim();
        csv.votoJustificavel = (currentRecord[4].trim().toUpperCase() == "SIM") ? true : false;
        csv.parametroJustificativa = currentRecord[5].trim();
        csv.email = currentRecord[6].trim();
        csv.login = currentRecord[7].trim();
        csv.formularioPreenchido = (currentRecord[8].trim().toUpperCase() == "SIM") ? true : false;
        csvArr.push(csv);
      }
    }
    return csvArr;
  }

  importarCsv(event) {
    this.zerarInputFile();

    let arquivos = event.srcElement.files;

    if (this.validaTipoArquivo(arquivos[0])) {
      let input = event.target;
      let fileReader = new FileReader();
      fileReader.readAsText(input.files[0]);

      fileReader.onload = () => {
        let csvData = fileReader.result;
        let csvRecordsArray = csvData.toString().split(/\r\n|\n/);
        let headersRow = this.utils.getHeaderArray(csvRecordsArray);
        this.candidatosArray = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);
        this.candidatoCsvParaNovosCandidatoDTO(this.candidatosArray);
        this.validaNavTab();
      };
    } else {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'O arquivo selecionado não é um .csv válido!' });
      this.candidatosArray = [];
    }
  }

  private async insercaoEmMassa(candidatos: PreCandidatoCsvDTO[]) {
    this.btOff = true;
    document.body.style.cursor = 'wait';
    await this.canditadosService.insercaoEmMassaPreCandidatos(candidatos, this.token).then(() => {
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'PreCandidatos enviados com sucesso!' });
      this.btOff = false;
      document.body.style.cursor = 'default';
      this.candidatoComponent.listarPreCandidatosExistentes();
    }, error => {
      this.btOff = false;
      document.body.style.cursor = 'default';
      this.messageService.add({ key: 'toast', severity: 'error', summary: '', detail: error });
    });
  }

  importarList() {
    this.insercaoEmMassa(this.newCandidatosArray);
  }

  candidatoCsvParaNovosCandidatoDTO(candidatoCsv: PreCandidatoCsvDTO[]) {
    this.candidaturaId = JSON.parse(sessionStorage.getItem("candidaturaId"));
    for(let candidato of candidatoCsv) {
      let novoCandidato: PreCandidatoCsvDTO = new PreCandidatoCsvDTO();
      const idCargo = this.getIdCargo(candidato.cargo.nome);
      novoCandidato.nome = candidato.nome;
      novoCandidato.cpf = candidato.cpf;
      novoCandidato.cargo = { "id": idCargo, "nome": candidato.cargo.nome };
      novoCandidato.cargoId =idCargo;
      novoCandidato.curriculum = candidato.curriculum;
      novoCandidato.votoJustificavel = candidato.votoJustificavel;
      novoCandidato.parametroJustificativa = candidato.parametroJustificativa;
      novoCandidato.candidatura = { "id": this.candidaturaId }
      novoCandidato.email = candidato.email;
      novoCandidato.login = candidato.login;
      novoCandidato.formularioPreenchido = candidato.formularioPreenchido;
      

      if (!novoCandidato.login || novoCandidato.login == ""){
        this.candidatosCriticados.push({ novoCandidato, critica: "Validação 1" });
      } else if (candidato.cargo.nome && candidato.cargo.nome != "" && !idCargo) {
        this.candidatosCriticados.push({ novoCandidato, critica: "Validação 3" });
      } else if (!this.isValidCPF(novoCandidato.cpf)) {
        this.candidatosCriticados.push({ novoCandidato, critica: "Validação 4" });
      } else if(novoCandidato.votoJustificavel == null){
        this.candidatosCriticados.push({ novoCandidato, critica: "Validação 5" });
      } else if(novoCandidato.votoJustificavel && (!novoCandidato.parametroJustificativa || novoCandidato.parametroJustificativa == "")){
        this.candidatosCriticados.push({ novoCandidato, critica: "Validação 6" });
      }else {
        this.newCandidatosArray.push(novoCandidato);
      }
    }
  }

  validaNavTab() {
    if (this.candidatosCriticados.length > 0 && this.candidatosDuplicados.length == 0 && this.candidatosEnviados.length == 0) {
      this.ativaNavValidacao = true;
    } else {
      this.ativaNavValidacao = false;
    }

    if (this.candidatosCriticados.length == 0 && this.newCandidatosArray.length > 0) {
      this.ativaNavEnviar = true;
    } else {
      this.ativaNavEnviar = false;
    }
  }

  getIdCargo(cargo: string) {
    const cargoObj = this.listaCargos.find(element => element.nome == cargo)
    if (cargoObj){
      return cargoObj.id;
    }
    return null;
  }

  isValidCPF(cpf: any) {
    if (!cpf || cpf == '' ) {
      return true;
    }
    cpf = cpf.replace(/[^\d]+/g,'');
    if (cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999") {
      return false;
    }
    let sum = 0;
    for (let i=0; i < 9; i ++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let rest = (sum * 10) % 11;
    if (rest == 10 || rest == 11) {
      rest = 0;
    }
    if (rest != parseInt(cpf.charAt(9))) {
      return false;
    }

    sum = 0;
    for (let i = 0; i < 10; i ++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rest =  (sum * 10) % 11;
    if (rest == 10 || rest == 11) {
      rest = 0;
    }
    if (rest != parseInt(cpf.charAt(10))) {
      return false;
    }
    return true;
  }
}